import { render, staticRenderFns } from "./ScoreGenerationConfirmationWidget.vue?vue&type=template&id=1724507c"
import script from "./ScoreGenerationConfirmationWidget.vue?vue&type=script&lang=js"
export * from "./ScoreGenerationConfirmationWidget.vue?vue&type=script&lang=js"
import style0 from "./ScoreGenerationConfirmationWidget.vue?vue&type=style&index=0&id=1724507c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports